<div
    [ngClass]="alertClass"
    role="alert"
>
    <div class="m-alert__icon">
        <i class="flaticon-pie-chart la {{ isStatic ? '' : 'la-spin' }}" aria-hidden="true"></i>
    </div>
    <div class="m-alert__text">
        <ng-container *ngIf="audience.type === AUDIENCE_TYPE.CSV">
            <h5>
                <span *ngIf="!audience.name" i18n>Esta</span>
                <em *ngIf="audience.name">"{{ audience.name }}"</em>
                <span i18n> es una audiencia estática.</span>
            </h5>
            <span i18n>
                Las audiencias estáticas se calculan una única vez, en el momento en que se cargan en EMMA.
            </span>
        </ng-container>
        <ng-container *ngIf="audience.type === AUDIENCE_TYPE.PERFORMANCE_REPORT || audience.type === AUDIENCE_TYPE.EVENT_DETAIL">
            <h5>
                <span *ngIf="!audience.name" i18n>Esta</span>
                <em *ngIf="audience.name">"{{ audience.name }}"</em>
                <span i18n> es una audiencia estática.</span>
            </h5>
            <span *ngIf="audience.type === AUDIENCE_TYPE.PERFORMANCE_REPORT" i18n>
                Las audiencias estáticas de informes de rendimiento se calculan una única vez, en el momento
                en que se crean.
            </span>
            <span *ngIf="audience.type === AUDIENCE_TYPE.EVENT_DETAIL" i18n>
                Las audiencias estáticas de detalles de eventos se calculan una única vez, en el momento
                en que se crean.
            </span>
        </ng-container>
        <ng-container *ngIf="audience.type === AUDIENCE_TYPE.EXTERNAL">
            <h5>
                <span *ngIf="!audience.name" i18n>Esta</span>
                <em *ngIf="audience.name">"{{ audience.name }}"</em>
                <span i18n> es una audiencia dinámica de una fuente externa.</span>
            </h5>
            <span i18n> Las audiencias dinámicas de fuentes externas reciben los datos en tiempo real. </span>
        </ng-container>
        <ng-container *ngIf="!isStatic && audience.type !== AUDIENCE_TYPE.EXTERNAL">
            <h5>
                <span *ngIf="!audience.name" i18n>Esta</span>
                <em *ngIf="audience.name">"{{ audience.name }}"</em>
                <span i18n> es una audiencia dinámica.</span>
            </h5>
            <p i18n>Las audiencias dinámicas se recalculan cada 24 horas.</p>
            <p *ngIf="hasAudienceExternal" i18n>
                Como el segmento utiliza una audiencia de una fuente externa,
                <strong>no podrá ser usada para las comunicaciones.</strong>
            </p>
        </ng-container>
    </div>
</div>
